import { render, staticRenderFns } from "./OldRegistration.vue?vue&type=template&id=52f1f204&"
import script from "./OldRegistration.vue?vue&type=script&lang=js&"
export * from "./OldRegistration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports